import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Modal,
  Button,
  Space,
  Col,
  Image,
  Divider,
  Typography,
} from 'antd';
import { message, FormLabel, DataGridPlus, BoolCell } from 'components/common';
import { CloseOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { getAllPackageList } from 'services/shipment';
import {
  getDefaultpackageId,
  getProductFlatRateOptionList,
  delProductFlatRateOptionById,
} from 'services/product';
import AddEditDialog from './AddFlatRateDialog';
import {
  WEIGHT_UNITS as weightUnitEnum,
  DIMENSION_UNITS as unitEnum,
} from 'constants/config';

const { Text } = Typography;

interface ProductPackageProps {
  visible: boolean;
  onHide: () => void;
  //   onRefresh: () => void;
  product: ProductRow;
}

// eslint-disable-next-line
export default (props: ProductPackageProps) => {
  const { visible, onHide, product } = props;
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [packages, setPackages] = useState<any[]>([]);
  const [selectedPakage, setSelectedPakcge] = useState<any>();
  const [info, setInfo] = useState<any>();
  const [packageId, setPackageId] = useState<number>();
  const [isOriginPackage, setIsOriginPacakge] = useState(false);
  const [current, setCurrent] = useState();
  const [flatRateOptionList, setFlatRateOptionList] = useState<any[]>([]);
  const [dialogVisible, setDialogVisible] = useState(false);
  // const [packageMaxQty, setPackageMaxQty] = useState<number>();

  const [form] = Form.useForm();
  document.body.style.overflowY = 'hidden';

  const getColumns = () => {
    return [
      {
        name: 'carrierName',
        header: 'Carrier',
        defaultFlex: 1,
        userSelect: true,
        sortable: false,
        // render: (value: any) => {
        //   const { data, rowIndex } = value;
        //   return <span id={`carrier_row_${rowIndex}`}>{data.carrierName}</span>;
        // },
      },
      {
        name: 'Qualified',
        header: 'qualified',
        defaultFlex: 1,
        sortable: false,
        render: (value: any) => {
          const { data } = value;
          return <BoolCell value={data.qualified} />;
        },
      },
      {
        name: 'carrierPackageName',
        header: 'Package',
        userSelect: true,
        defaultFlex: 1,
        sortable: false,
      },
      {
        name: 'packageMaxQty',
        header: 'Max Qty',
        defaultFlex: 1,
        sortable: false,
      },
      {
        name: 'action',
        header: 'Action',
        showColumnMenuTool: false,
        groupBy: false,
        sortable: false,
        textAlign: 'center',
        minWidth: 250,
        render: (value: any) => {
          const { data, rowIndex } = value;
          return (
            <Space>
              <Button
                id={`action_row_${rowIndex}_edit`}
                type="link"
                onClick={() => {
                  setCurrent(data);
                  setDialogVisible(true);
                }}
              >
                Edit
              </Button>
              <Button
                id={`action_row_${rowIndex}_delete`}
                type="link"
                onClick={() => {
                  Modal.confirm({
                    title: 'Are you sure you want to delete the row ?',
                    content: ``,
                    okText: 'Yes',
                    okType: 'default',
                    okButtonProps: { className: "hover-danger-button" },
                    cancelText: 'No',
                    autoFocusButton: 'cancel',
                    onCancel() { },
                    onOk() {
                      delFlatRate(data);
                    },
                  });
                }}
              >
                Delete
              </Button>
            </Space>
          );
        },
      },
    ];
  };

  const getDefaultPackage = async () => {
    if (!product || !product.id) {
      message.error({
        content: 'invalid product',
      });
      return;
    }
    try {
      setLoading1(true);
      const res = await getDefaultpackageId(product.id);
      setLoading1(false);
      if (res.isSuccess) {
        setInfo(res.data);
        setPackageId(res.data.shippingCustomPackageNum);
        if (res.data.shippingCustomPackageNum === 1) {
          setIsOriginPacakge(true);
        }
        // setPackageMaxQty(res.data.packageMaxQty || 1);
      }
    } catch (error) {
      setLoading1(false);
    }
  };

  const getPackageList = async () => {
    try {
      setLoading(true);
      const res = await getAllPackageList();
      setLoading(false);
      setPackages(
        res.filter(
          (i) => i.shippingCustomPackageNum || i.shippingCustomPackageNum === 0
        )
      );
    } catch (error) {
      setLoading(false);
    }
  };

  const getFlatRateList = async () => {
    try {
      setLoading2(true);
      const res = await getProductFlatRateOptionList(product.id);
      setLoading2(false);
      if (res.isSuccess) {
        setFlatRateOptionList(res.data);
      }
    } catch (error) {
      setLoading2(false);
    }
  };

  const delFlatRate = async (item: any) => {
    try {
      const res = await delProductFlatRateOptionById(
        item.productFlatRateOptionNum
      );
      if (res.isSuccess) {
        message.success({ content: 'Deleted successfully' });
        getFlatRateList();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    const cancel = form.isFieldsTouched();
    if (!cancel) {
      document.body.style.overflowY = 'unset';
      onHide();
    } else {
      Modal.confirm({
        title: 'Leave / Refresh Page?',
        okText: 'Leave',
        cancelText: 'Cancel',
        content: `Changes you made may not be saved.`,
        afterClose: () => {
          //fuck antd bug!
          setTimeout(() => {
            document.body.style.overflowY = 'unset';
          }, 0);
        },
        onOk() {
          onHide();
        },
      });
    }
  };
  /* eslint-disable */
  useEffect(() => {
    getDefaultPackage();
    getPackageList();
    getFlatRateList();
  }, []);
  useEffect(() => {
    if ((packageId || packageId === 0) && packages) {
      const temp = packages.filter(
        (i) => i.shippingCustomPackageNum === packageId
      );
      if (temp.length > 0) {
        setSelectedPakcge(temp[0]);
      }
    }
  }, [packageId, packages]);
  /* eslint-enable */
  //   const layout = {
  //     labelCol: { span: 6 },
  //     wrapperCol: { span: 14 },
  //   };
  return (
    <Modal
      title="Flat Rate Option"
      centered
      visible={visible}
      maskClosable={false}
      width={900}
      destroyOnClose={true}
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button id="close_button" type="primary" onClick={handleCancel} icon={<CloseOutlined />}>
              Close
            </Button>
          </Space>
        </Row>
      }
    >
      <Spin
        spinning={loading || loading1 || loading2}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Row>
          <Col span={12}>
            <Space direction="vertical" size={4}>
              <Space>
                <FormLabel>SKU</FormLabel>
                <span>{info?.sku}</span>
              </Space>

              <Space>
                <FormLabel>Product Name</FormLabel>
                <Space>
                  <Text
                    style={{ width: 150 }}
                    ellipsis={{ tooltip: info?.productTitle }}
                  >
                    {info?.productTitle}{' '}
                  </Text>
                </Space>
              </Space>

              <Space>
                <FormLabel>UPC</FormLabel>
                <Space>{info?.upc}</Space>
              </Space>
            </Space>
          </Col>
          <Col span={8}>
            <Image
              width={60}
              src={info?.thumbnailUrl || 'error'}
              fallback="data:image/png;base64,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"
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Space direction="vertical" size={4}>
              <Space>
                <FormLabel>Product Size</FormLabel>
                {info?.productLength ||
                  info?.productWidth ||
                  info?.productHeight ? (
                  <Space>
                    {' '}
                    <span>{`L: ${info?.productLength || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`W: ${info?.productWidth || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`H: ${info?.productHeight || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                  </Space>
                ) : null}
              </Space>
              <Space>
                <FormLabel>{`Net Weight (${weightUnitEnum[info?.weightUnit || 0]
                  })`}</FormLabel>
                <Space>{info?.netWeight}</Space>
              </Space>
              <Space>
                <FormLabel>Default Package</FormLabel>
                <Space>{selectedPakage?.name}</Space>
              </Space>

              <Space>
                <FormLabel>Package Max Qty</FormLabel>
                <Space>{info?.packageMaxQty}</Space>
              </Space>
            </Space>
          </Col>

          <Col span={12}>
            <Space direction="vertical" size={4}>
              <Space>
                <FormLabel>Box Size</FormLabel>
                {info?.boxLength || info?.boxWidth || info?.boxHeight ? (
                  <Space>
                    <span>{`L: ${info?.boxLength || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`W: ${info?.boxWidth || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                    <span>{`H: ${info?.boxHeight || 0} ${unitEnum[info?.dimensionUnit || 0]
                      }`}</span>
                  </Space>
                ) : null}
              </Space>
              <Space>
                <FormLabel>Gross Weight</FormLabel>
                <Space>
                  {info?.grossWeight
                    ? `${info?.grossWeight} ${weightUnitEnum[info?.weightUnit || 0]
                    }`
                    : ''}
                </Space>
              </Space>

              <Space>
                <FormLabel>Package Size</FormLabel>
                <Space>
                  {isOriginPackage ? (
                    <span>Pacakge size is the same as the box size</span>
                  ) : selectedPakage?.length ||
                    selectedPakage?.width ||
                    selectedPakage?.height ? (
                    <Space size="middle">
                      <span>{`L: ${selectedPakage?.length || 0} ${unitEnum[selectedPakage?.lengthUnits || 0]
                        }`}</span>
                      <span>{`W: ${selectedPakage?.width || 0} ${unitEnum[selectedPakage?.lengthUnits || 0]
                        }`}</span>
                      <span>{`H: ${selectedPakage?.height || 0} ${unitEnum[selectedPakage?.lengthUnits || 0]
                        }`}</span>
                    </Space>
                  ) : null}
                </Space>
              </Space>
            </Space>
          </Col>
        </Row>
        <Divider style={{ marginTop: 6, marginBottom: 8 }} />

        <Row justify="start">
          <Button
            id="add_flat_rate_button"
            type="primary"
            onClick={() => {
              setCurrent(undefined);
              setDialogVisible(true);
            }}
          >
            <PlusOutlined />
            Add Flat Rate
          </Button>
        </Row>

        {
          <DataGridPlus
            style={{ maxHeight: 300 }}
            idProperty="productFlatRateOptionNum"
            columns={getColumns()}
            dataSource={flatRateOptionList}
            loading={loading}
            pagination="local"
            {...({} as any)}
          />
        }
      </Spin>
      {dialogVisible && (
        <AddEditDialog
          visible
          onHide={() => setDialogVisible(false)}
          onRefresh={() => getFlatRateList()}
          product={product}
          flatRate={current}
        />
      )}
    </Modal>
  );
};
